import React from "react";
import {executeQuery} from "../../requests/executeQuery";
/* import {HSC_HOTLIST_PROPERTIES,
    HSC_HOTLIST_AGENTS,
    HSC_HOTLIST_INVESTORS
} from '../../consts/queries'; */
import { HSC_HOTLIST_PROPERTIES,HSC_HOTLIST_AGENTS, HSC_HOTLIST_INVESTORS, HSC_HOTLIST_COURTING,HSC_HOTLIST_FOLLOW_UP, HSC_HOTLIST_LENDERS } from '../Graphql/Queries/HscHotlistQuery';
import { fetchData } from '../Service/graphQlService';
import { GET_CONTACT_TEAM_BY_ID } from "../Graphql/ContactsQueries/contactsQuery";

import {getData} from "../../requests/CRUD";
import PipelineDetails, { agent, investor, property, courting, lender, followup} from "../PipelineDetails/PipelineDetails";
import {TEAM} from "../../consts/tables";

export default class HotlistPipelineDetails extends PipelineDetails {
    constructor(props) {
        super(props);

        this.state = {
            tables: {
                [courting]: {
                    name: 'Courting',
                    data: [],
                    total: {},
                },
                [property]: {
                    name: 'Properties',
                    data: [],
                    total: {},
                },
                [agent]: {
                    name: 'Agents',
                    data: [],
                    total: {},
                },
                [investor]: {
                    name: 'Investors',
                    data: [],
                    total: {},
                },
                [lender]: {
                    name: 'Lenders',
                    data: [],
                    total: {},
                },   
                [followup]: {
                    name: 'Follow Up',
                    data: [],
                    total: {},
                },              
            },
            agentName: '',
            loading: true,
            componentName: 'agentPipelineDetails',
            currentUserEmail: ''
        };
    }

  /*   static createOptionsWithOnlyEmailId({emailId}) {
        return {
            param: {
                HSC_MEMBER_MAIL_ID : emailId
            },        
        };
    }
    static createOptions({id}) {
        return {
            param: {
                HSC_AGENT_ID : id
            },        
        };
    }
    */

    buildTables(res) {
        const tables = {...this.state.tables};
        const id = this.props.location && this.props.location.state && this.props.location.state.id ? this.props.location.state.id :
            (this.props.id ? this.props.id : this.props.params.id); 
        const isNotEmptyRow = (item) => Object.values(item).some(value => value !== null && value !== "");
        const investorData =  res[2].data.hscHotlistInvestors.data.filter(isNotEmptyRow);    
        tables[courting] = HotlistPipelineDetails.buildTable(courting,  tables[courting], res[4].data.hscHotlistCourting.data, "", id);
        tables[property] = HotlistPipelineDetails.buildTable(property,  tables[property], res[0].data.hscHotlistProperties.data, "", id);
        tables[agent] = HotlistPipelineDetails.buildTable(agent,  tables[agent], res[1].data.hscHotlistAgents.data, "", id);
        tables[investor] = HotlistPipelineDetails.buildTable(investor,  tables[investor], [...investorData], "", id);
        tables[lender] = HotlistPipelineDetails.buildTable(lender,  tables[lender], res[3].data.hscHotlistLenders.data, "", id);
        
        tables[followup] = HotlistPipelineDetails.buildTable(followup,  tables[followup], res[5].data.hscHotlistFollowup.data, "", id);
        
        this.setState({tables});
    }

    fetch(id,hscEmail) {   
        if(id && typeof(id) !== 'string'){
            id = id.toString();
        }          
        /* const hasOptions = HotlistPipelineDetails.createOptions({
            id: id
        });
        const hotListPropertiesOptions = HotlistPipelineDetails.createOptionsWithOnlyEmailId({
            emailId: hscEmail
        }); */
        let agentName = this.props.location && this.props.location.state ? this.props.location.state.name : this.props.name;
        Promise.all([     
                            
            fetchData(HSC_HOTLIST_PROPERTIES,  { hscMemberMailId: hscEmail }),
            fetchData(HSC_HOTLIST_AGENTS, { hscMemberMailId: hscEmail }),
            fetchData(HSC_HOTLIST_INVESTORS, { hscMemberMailId: hscEmail }) ,
            fetchData(HSC_HOTLIST_LENDERS, { hscMemberMailId: hscEmail }) ,
            fetchData(HSC_HOTLIST_COURTING, { hscMemberMailId: hscEmail }) ,
            fetchData(HSC_HOTLIST_FOLLOW_UP, { hscMemberMailId: hscEmail }) 

        ]).then(res => {
            if (res && res[0]  && Array.isArray(res[0].data.hscHotlistProperties.data) &&
                res[1]  && Array.isArray(res[1].data.hscHotlistAgents.data) &&
                res[2]  && Array.isArray(res[2].data.hscHotlistInvestors.data) &&
                res[3]  && Array.isArray(res[3].data.hscHotlistLenders.data) &&
                res[4]  && Array.isArray(res[4].data.hscHotlistCourting.data) && 
                res[5]  && Array.isArray(res[5].data.hscHotlistFollowup.data))   {
                    this.setState({agentName}, () => this.buildTables(res));
                }       
            this.setState({loading: false});           
                               
        });


       /*  const requests = [           
            executeQuery({queryName: HSC_HOTLIST_PROPERTIES, options: hotListPropertiesOptions}),
            executeQuery({queryName: HSC_HOTLIST_AGENTS, options: hasOptions}),
            executeQuery({queryName: HSC_HOTLIST_INVESTORS , options: hasOptions}),
            executeQuery({queryName: HSC_HOTLIST_BUYERS , options: hasOptions}),            
        ];
        let agentName = this.props.location && this.props.location.state ? this.props.location.state.name : this.props.name;
        const options = {
            column: [
                'ON_PHONES',
                'FIRST_NAME',
                'LAST_NAME',
                'EMAIL'
            ],
            filter: [{
                'text': id,
                'code': 'ARCIMEDES_ROW_ID',
                'type': 'exact',
            }],
        };
        requests.push(getData({tableCode: TEAM, options}));
        if (!agentName) {
            const options = {
                column: [
                    'FIRST_NAME',
                    'LAST_NAME',
                ],
                filter: [{
                    'text': id,
                    'code': 'ARCIMEDES_ROW_ID',
                    'type': 'exact',
                }],
            };
            requests.push(getData({tableCode: TEAM, options}));
        }
        Promise.all(requests).then(async (res) => {       
            if (res && res[0] && res[0].success && Array.isArray(res[0].data) &&
                res[1] && res[1].success && Array.isArray(res[1].data) &&
                res[2] && res[2].success && Array.isArray(res[2].data)&&
                res[3] && res[3].success && Array.isArray(res[3].data))   {
                    this.setState({agentName}, () => this.buildTables(res));
                }       
            this.setState({loading: false});
        }); */
    }
    
    componentDidMount() {
        const id = this.props.params && this.props.params.id ? this.props.params.id : ''; 
        const hscEmail = this.props.params && this.props.params.email ? this.props.params.email : '';        
        if (hscEmail) {
            this.fetch(id,hscEmail);
            return;
        }
        this.setState({loading: false});
    }
}